<template>
  <div class="append-booking-container">
    <vxe-grid
      ref="grid"
      size="small"
      row-id="shipmentBookingCode"
      border
      resizable
      auto-resize
      show-overflow
      highlight-hover-row
      :data="data"
      :columns="tableColumns"
      :loading="loading"
      :height="600"
      :radio-config="{ trigger: 'row', highlight: true, strict: false }"
      @radio-change="$emit('radio-change', $event)"
    >
      <template #bookingTypeNameHeader>
        <filter-content
          :text="$l('form_label_bookingType') || '订舱类型'"
          :items="options.bookingTypeName"
          @filter="(e) => $emit('change-filter', { field: 'bookingTypeName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #dispatchPortNameHeader>
        <filter-content
          :text="$l('form_label_dispatchPort') || '发运港口'"
          :items="options.dispatchPortName"
          @filter="(e) => $emit('change-filter', { field: 'dispatchPortName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #destinationPortNameHeader>
        <filter-content
          :text="$l('form_label_destinationPort') || '目的港口'"
          :items="options.destinationPortName"
          @filter="(e) => $emit('change-filter', { field: 'destinationPortName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #destinationPortFullNameHeader>
        <filter-content
          :text="$l('form_label_deliveryPort') || '指运港'"
          :items="options.destinationPortFullName"
          @filter="(e) => $emit('change-filter', { field: 'destinationPortFullName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #destinationCountryHeader>
        <filter-content
          :text="$l('form_label_destinationCountry') || '目的国'"
          :items="options.destinationCountry"
          @filter="(e) => $emit('change-filter', { field: 'destinationCountry', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #shipmentTypeNameHeader>
        <filter-content
          :text="$l('table_label_dispatchType') || '出运方式'"
          :items="options.shipmentTypeName"
          @filter="(e) => $emit('change-filter', { field: 'shipmentTypeName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #quotedMethodNameHeader>
        <filter-content
          :text="$l('form_label_quotedMethod') || '报价方式'"
          :items="options.quotedMethodName"
          @filter="(e) => $emit('change-filter', { field: 'quotedMethodName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #deliveryDateHeader>
        <filter-content
          :text="$l('table_label_loadingDate') || '产装日期'"
          :items="options.deliveryDate"
          @filter="(e) => $emit('change-filter', { field: 'deliveryDate', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #etaHeader>
        <filter-content
          :text="$l('table_label_eta') || '到港日期'"
          :items="options.eta"
          @filter="(e) => $emit('change-filter', { field: 'eta', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #fbaArrivalDateHeader>
        <filter-content
          :text="$l('form_label_fbaArrivalDate') || '到FBA日期'"
          :items="options.fbaArrivalDate"
          @filter="(e) => $emit('change-filter', { field: 'fbaArrivalDate', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #bookingScmNameHeader>
        <filter-content
          :text="$l('form_label_bookingScmCode') || '订舱货代'"
          :items="options.bookingScmName"
          @filter="(e) => $emit('change-filter', { field: 'bookingScmName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #customsBrokerScmNameHeader>
        <filter-content
          :text="$l('form_label_customsBrokerScmCode') || '报关货代'"
          :items="options.customsBrokerScmName"
          @filter="(e) => $emit('change-filter', { field: 'customsBrokerScmName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #domesticTransitNameHeader>
        <filter-content
          :text="$l('form_label_domesticTransitScmCode') || '境内运输公司'"
          :items="options.domesticTransitName"
          @filter="(e) => $emit('change-filter', { field: 'domesticTransitName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #overseasTransitNameHeader>
        <filter-content
          :text="$l('form_label_overseasTransitScmCode') || '境外运输公司'"
          :items="options.overseasTransitName"
          @filter="(e) => $emit('change-filter', { field: 'overseasTransitName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #shipperNameHeader>
        <filter-content
          :text="$l('form_label_shipperCode') || '发货人'"
          :items="options.shipperName"
          @filter="(e) => $emit('change-filter', { field: 'shipperName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #consigneeNameHeader>
        <filter-content
          :text="$l('form_label_consigneeCode') || '收货人'"
          :items="options.consigneeName"
          @filter="(e) => $emit('change-filter', { field: 'consigneeName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #notifierNameHeader>
        <filter-content
          :text="$l('form_label_notifierCode') || '通知人'"
          :items="options.notifierName"
          @filter="(e) => $emit('change-filter', { field: 'notifierName', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #shipVoyageHeader>
        <filter-content
          :text="$l('form_label_shipVoyage') || '船名航次'"
          :items="options.shipVoyage"
          @filter="(e) => $emit('change-filter', { field: 'shipVoyage', value: e })"
          submitFilterOnClose
        />
      </template>
      <template #bookingDateHeader>
        <filter-content
          :text="$l('form_label_bookingDate') || '订舱日期'"
          :items="options.bookingDate"
          @filter="(e) => $emit('change-filter', { field: 'bookingDate', value: e })"
          submitFilterOnClose
        />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from './table-columns'

export default {
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    options: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    clearRadioRow() {
      const grid = this.$refs.grid
      if (grid && grid.clearRadioRow) {
        grid.clearRadioRow()
      }
    },
  },
}
</script>
